exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RSVP__container___Ba5p7 {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-bottom: 0;\n}\n\n.RSVP__container___Ba5p7 {\n  /* Computed as guest width + (2 * spacing-s) */\n  max-width: 269px;\n}\n\n@media (min-width: 538px) {\n  .RSVP__container___Ba5p7 {\n    max-width: 538px;\n  }\n}\n\n@media (min-width: 807px) {\n  .RSVP__container___Ba5p7 {\n    max-width: 807px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "RSVP__container___Ba5p7"
};